import React from 'react'

// ProPublica components
import WidgetLayout from '../../components/layouts/WidgetLayout'
import TicketMap from '../../components/viz/TicketMap'
import URL from 'url-parse'
import pick from 'lodash/pick'


// Widget page
class WidgetPage extends React.Component {

  state = {
    showCredit: false,
  }

  componentDidMount() {
    if (typeof window != 'undefined') {
      // Wait a second. Terribly hacky but works fine.
      setTimeout(() => {
        const loc = new URL(window.location.href, true)
        const query = pick(loc.query, ['parentUrl'])
        const showCredit = query.parentUrl && !query.parentUrl.includes('propublica.org');
        this.setState({ showCredit });
      }, 1000);
    }
  }

  render() {
    const { showCredit } = this.state;

    return (<WidgetLayout config={this.props.data.configYaml}>
      <TicketMap
        ticketData={this.props.data.dataJson}
      />
      <div className="info">
        <p><strong>Note:</strong> Rates were calculated using ticket data on all instances when one vehicle received multiple citations for not having a city sticker on the same day in that community area between 2011 and 2015, joined with demographic data from the American Community Survey data from the same period. The ACS data was obtained from the Chicago Metropolitan Agency for Planning.</p>

        {(showCredit) &&
          <p><strong>Credit:</strong> David Eads/ProPublica Illinois, Elliot Ramos/WBEZ</p>
        }
      </div>
    </WidgetLayout>)
  }
}

export default WidgetPage

/**
 *
 */
export const query = graphql`
  query WidgetQuery {
  dataJson {
    type
    features {
      type
      geometry {
        type
        coordinates
      }
      properties {
        perimeter
        black_pop
        TOT_POP
        shape_area
        HISP
        white_pop
        area_numbe
        ticket_rate
        area
        MEDINC
        community
        hisp_pop
        comarea
        area_num_1
        shape_len
        WHITE
        ticket_count
        BLACK
        TOT_HH
        comarea_id
      }
    }
  }
    configYaml {
      description
      title
      meta {
        name
        content
        http_equiv
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/widget/index.js